import { render, staticRenderFns } from "./ChangeExerciseDialog.vue?vue&type=template&id=56e79653"
import script from "./ChangeExerciseDialog.vue?vue&type=script&lang=js"
export * from "./ChangeExerciseDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports